module.exports = __webpack_public_path__ + "static/profhilo-after-851a2309c467c3bd6255c96613952677.jpg";